// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/contracts.

import { useBackend } from '../useBackend'

/** POST /api/contracts/getRollout */
export function useGetRollout<T = any>() {
  return useBackend<T>('contracts/getRollout')
}

/** POST /api/contracts/getRolloutSummary */
export function useGetRolloutSummary<T = any>() {
  return useBackend<T>('contracts/getRolloutSummary')
}

/** POST /api/contracts/sendNewContract */
export function useSendNewContract<T = any>() {
  return useBackend<T>('contracts/sendNewContract')
}

/** POST /api/contracts/sendNewContractBulk */
export function useSendNewContractBulk<T = any>() {
  return useBackend<T>('contracts/sendNewContractBulk')
}
